import { BespokePrompt } from "@freeplay/shared-code";
import React from "react";
import { Group } from "../picks/Group";
import { BespokeOptionDisplay } from "./BespokeOptionDisplay";

type IndividualBespokeOutcomeDisplayProps = {
    prompt: BespokePrompt;
    selection?: number;
};

export const IndividualBespokePromptDisplay = ({
    prompt,
    selection,
}: IndividualBespokeOutcomeDisplayProps): JSX.Element => {
    return (
        <Group groupTitle={prompt.prompt}>
            {prompt.options.map((option, index) => {
                return (
                    <BespokeOptionDisplay
                        key={`bespoke-option-${option}-${index}`}
                        labelText={option}
                        index={index}
                        selected={index === selection}
                        resulted={prompt.selectedOption !== null}
                        winIndex={prompt.selectedOption}
                        isLast={index === prompt.options.length - 1}
                    />
                );
            })}
        </Group>
    );
};
